// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"5949bd90","299":"9839b3ec","453":"86f98b88","478":"1afd649a","557":"67db2df2"}[chunkId] + ".chunk.js";
};